import { createFileRoute } from '@tanstack/react-router';

import { CustomerMemberDetailPage } from '../user/detail/CustomerMemberDetailPage';

export const Route = createFileRoute('/_app/customer-groups/$groupId/members/$userId')({
    component: CustomerMemberDetailPage,
});
